// extracted by mini-css-extract-plugin
module.exports = {"main-component":"leaderboardSvg_main-component__2GoPu"};